import * as tslib_1 from "tslib";
import { ElementRef, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { merge, Subject } from 'rxjs';
import { debounceTime, switchMap, takeUntil, tap } from 'rxjs/operators';
import { DialogLocationsGroupsComponent } from './dialogs/dialog-locations-groups.component';
import { FiltersComponent } from './filters/filters.component';
import { LocationsGroupsService } from './services/locations-groups-resolver.service';
import { AuthenticationService } from '@core/authentication/authentication.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var LocationsGroupsComponent = /** @class */ (function () {
    function LocationsGroupsComponent(fuseTranslationLoaderService, locationsGroupsService, authenticationService, fuseSidebarService, matDialog) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.locationsGroupsService = locationsGroupsService;
        this.authenticationService = authenticationService;
        this.fuseSidebarService = fuseSidebarService;
        this.matDialog = matDialog;
        this.displayedColumns = ['name', 'description', 'createdAt', 'edit'];
        this.locationsGroups = [];
        this.loading = true;
        this.locationsGroupsReload = new Subject();
        this.subscriptions = new Subject();
        this.hasEditLocationGroupPermission = this.authenticationService.hasPermission('locations-groups-edit');
        this.hasCreateLocationGroupPermission = this.authenticationService.hasPermission('locations-groups-create');
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    LocationsGroupsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.sort.active = 'name';
        this.sort.direction = 'asc';
        merge(this.sort.sortChange, this.paginator.page, this.filterLocationsGroupsComponent.filterChanged.pipe(tap(function () { return _this.paginator.firstPage(); })), this.locationsGroupsReload)
            .pipe(debounceTime(500), takeUntil(this.subscriptions), switchMap(function () {
            _this.loading = true;
            _this.sort.direction = _this.sort.direction || 'asc';
            var options = {
                orderBy: _this.sort.active + "_" + _this.sort.direction,
                offset: _this.paginator.pageIndex * _this.paginator.pageSize,
                limit: _this.paginator.pageSize
            };
            return _this.locationsGroupsService.getLocationsGroups({
                where: _this.filterLocationsGroupsComponent.filterChanged.value,
                options: options
            });
        }))
            .subscribe(function (result) {
            _this.datatable.nativeElement.scrollTo({
                top: 0,
            });
            _this.locationsGroups = result.items;
            _this.totalCount = result.totalCount;
            _this.filtered = result.filtered;
            _this.loading = false;
        });
    };
    LocationsGroupsComponent.prototype.reload = function () {
        this.locationsGroupsReload.next();
    };
    LocationsGroupsComponent.prototype.toggleSidebarOpen = function (name) {
        this.fuseSidebarService.getSidebar(name).toggleOpen();
    };
    LocationsGroupsComponent.prototype.openDialog = function (locationGroupId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var locationGroup, dialog, reload;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.locationsGroupsService.getLocationGroup(locationGroupId)];
                    case 1:
                        locationGroup = _a.sent();
                        dialog = this.matDialog.open(DialogLocationsGroupsComponent, {
                            panelClass: ['dialog-locations-groups'],
                            data: {
                                locationGroup: locationGroup || {},
                                isViewMode: locationGroupId && !this.hasEditLocationGroupPermission
                            }
                        });
                        return [4 /*yield*/, dialog.afterClosed().toPromise()];
                    case 2:
                        reload = _a.sent();
                        if (reload) {
                            this.reload();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LocationsGroupsComponent.prototype.clearFilters = function () {
        this.filtered = false;
        this.filterLocationsGroupsComponent.clearFilters();
    };
    return LocationsGroupsComponent;
}());
export { LocationsGroupsComponent };
